/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Availabledates_Tuesday_May_1211Inputs */

const en__field__enum_availabledates_tuesday_may_1211 = /** @type {(inputs: _Field__Enum_Availabledates_Tuesday_May_1211Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuesday, May 12, 2026`)
};

const de__field__enum_availabledates_tuesday_may_1211 = /** @type {(inputs: _Field__Enum_Availabledates_Tuesday_May_1211Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dienstag, 12.05.2026`)
};

/**
* | output |
* | --- |
* | "Tuesday, May 12, 2026" |
*
* @param {_Field__Enum_Availabledates_Tuesday_May_1211Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_availabledates_tuesday_may_1211 = /** @type {((inputs?: _Field__Enum_Availabledates_Tuesday_May_1211Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Availabledates_Tuesday_May_1211Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_availabledates_tuesday_may_1211(inputs)
	return de__field__enum_availabledates_tuesday_may_1211(inputs)
});
export { _field__enum_availabledates_tuesday_may_1211 as "_field__enum_availableDates_TUESDAY_MAY_12" }